

import { ATBInfo } from '@/services/ATBInfo'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  props: {
    info: {
      type: Object as PropType<ATBInfo>,
      required: true
    }
  },
  methods: {
    formatDate (value: string | undefined) {
      return value ? new Date(value || '').toLocaleDateString() : ''
    }
  }
})
